import React, { useEffect, useState } from 'react'
import Header from './header'
import UserInput from './user-input'
import { gaPageViewSlotFinder } from '../../utils/network'
import Drawer from '../Drawer'
import DisplayArtworks from './display-artworks'


export default function SlotFinder() {
  const [expand, setExpand] = useState(true)
  useEffect(() => {
    gaPageViewSlotFinder()
  }, [])
  const isExpand = () => {
    setExpand(true)
  }
  const collapse = () => {
    setExpand(false)
  }
  return (
    <div>
      <Header headerFor='landingPage' />
      <DisplayArtworks />
      <Drawer open={true} heading="Search by"
        hideCloseButton={true}
        BackdropProps={true}
        backgroundColor='#ffffff'
        containerPadding={{ padding: '30px 10px 67px' }}
        headingPadding={{ padding: '0px 0px 0px 15px' }}
        height={expand ? '500px' : ''}
      >
        <UserInput isExpand={isExpand} collapse={collapse} />
      </Drawer>
    </div>
  )
}